// extracted by mini-css-extract-plugin
export default {"wrapper":"NoRecordFound_wrapper__03UG7"};